import {CompanyExtensionEntity} from "@dropDesk/domain/entities/plan_extensions/company_extension.entity";
import {PaymentEntity} from "@dropDesk/domain/entities/payment/payment.entity";

export interface PaymentExtensionEntityProps {
  companyId: string;
  extensionId: string;
  paymentId: string;
  companyExtension?: CompanyExtensionEntity;
  payment?: PaymentEntity;
}

export class PaymentExtensionEntity {
  companyId!: string;
  extensionId!: string;
  paymentId!: string;
  companyExtension?: CompanyExtensionEntity;
  payment?: PaymentEntity;

  constructor(props: PaymentExtensionEntityProps) {
    Object.assign(this, props);
  }

  static fromJson(json: Record<string, any>): PaymentExtensionEntity {
    return new PaymentExtensionEntity({
      companyId: json['companyId'],
      extensionId: json['extensionId'],
      paymentId: json['paymentId'],
      companyExtension: json['companyExtension']
        ? CompanyExtensionEntity.fromJson(json['companyExtension'])
        : undefined,
      payment: json['payment'] ? PaymentEntity.fromJson(json['payment']) : undefined
    });
  }

  copyWith(partial: Partial<PaymentExtensionEntityProps>): PaymentExtensionEntity {
    return new PaymentExtensionEntity({
      companyId: partial.companyId ?? this.companyId,
      extensionId: partial.extensionId ?? this.extensionId,
      paymentId: partial.paymentId ?? this.paymentId,
      companyExtension: partial.companyExtension ?? this.companyExtension,
      payment: partial.payment ?? this.payment
    });
  }
}
